











































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import {
  Activity,
  getActivities,
  postActivity,
  putActivity,
  ToPost,
  deleteActivity,
} from '../api/active';
import moment from 'moment';
import { aM, cA } from '@fullcalendar/core/internal-common';
import _uniqWith from 'lodash/uniqWith';
import { EventImpl } from '@fullcalendar/core/internal';
import { lowerFirst } from 'lodash';
import zhLocale from '@fullcalendar/core/locales/zh-cn';

type Event = { title: string; start: string; extendedProps: Activity };
type Ev = {
  name: string;
  date: string;
  endDate: string;
  place: string;
  relatedPeople: string;
  startTime?: Date;
  endTime?: Date;
  id: string;
  itemId: string;
  event?: EventImpl;
};

const formDefaultProps = {
  name: '',
  date: '',
  endDate: '',
  place: '',
  relatedPeople: '',
  startTime: undefined,
  endTime: undefined,
  id: '',
  itemId: '',
  event: undefined,
};
@Component
export default class ActivityCalendar extends Vue {
  lockSubmit = false;
  clickType: boolean = false;
  private listLoading: boolean = false;
  activitiesArr: Event[] = [];
  calendar: Calendar | undefined;
  dialogFormVisible: boolean = false;
  form: Ev = { ...formDefaultProps };
  rulesOnlyDate = {
    date: [{ required: true, message: '请选择日期', trigger: 'change' }],
  };
  rules: any = {
    name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
    ...this.rulesOnlyDate,
    place: [{ required: true, message: '请选择活动区域', trigger: 'blur' }],
    startTime: [{ required: true, message: '请选择开始时间', trigger: 'blur' }],
    endTime: [{ required: true, message: '请选择结束时间', trigger: 'blur' }],
  };
  disableDate(date: Date) {
    if (!this.form.endDate) {
      return false;
    }
    return moment(date).isSameOrAfter(this.form.endDate);
  }
  disableEndDate(date: Date) {
    if (!this.form.date) {
      return false;
    }
    return moment(date).isSameOrBefore(this.form.date);
  }

  formLabelWidth = '90px';
  mounted() {
    this.calendar = new Calendar(this.$refs.calendar as HTMLElement, {
      locale: zhLocale,
      plugins: [dayGridPlugin, interactionPlugin],
      initialView: 'dayGridMonth',
      // events: this.activitiesArr,
      headerToolbar: {
        start: 'title',
        center: '',
        end: 'today custom1,custom2',
      },
      customButtons: {
        custom1: {
          text: '<',
          click: () => {
            this.customClick(true);
          },
        },
        custom2: {
          text: '>',
          click: () => {
            this.customClick(false);
          },
        },
      },
      // 点击已有事件的操作
      eventClick: (info) => {
        this.clearForm();
        this.form.event = info.event;
        this.dialogFormVisible = true;
        const details = info.event.extendedProps;

        this.form.name = details.title;
        this.form.itemId = details.itemId;
        this.form.date = moment(details.date).format('YYYY-MM-DD');
        if (details.endDate) {
          this.form.endDate = moment(details.endDate).format('YYYY-MM-DD');
        }

        if (details.time) {
          this.form.startTime = this.convertTime(details.time.split('-')[0].trim());
          this.form.endTime = this.convertTime(details.time.split('-')[1].trim());
        } else {
          this.form.startTime = undefined;
          this.form.endTime = undefined;
        }
        // if (this.$refs.startTimeSelect)
        //   //@ts-ignore: fix element ui bug
        //   (this.$refs.startTimeSelect as Vue).userInput = this.form.startTime;
        // if (this.$refs.endTimeSelect)
        //   //@ts-ignore: fix element ui bug
        //   (this.$refs.endTimeSelect as Vue).userInput = this.form.endTime;
        this.form.place = details.place;
        this.form.relatedPeople = details.relatedPeople;
        this.form.id = details._id;
        this.clickType = true;
      },
      selectable: true,
      dateClick: (info) => {
        this.clearForm();
        this.form.date = info.dateStr;
        this.dialogFormVisible = true;
        this.clickType = false;
        if (this.$refs.startTimeSelect)
          //@ts-ignore: fix element ui bug
          (this.$refs.startTimeSelect as Vue).userInput = '';
        if (this.$refs.endTimeSelect)
          //@ts-ignore: fix element ui bug
          (this.$refs.endTimeSelect as Vue).userInput = '';
        // console.log(this.clickType);
      },
    });
    this.calendar!.render();
    this.activities();
  }

  get dialogTitle() {
    return this.clickType ? '编辑活动' : '添加活动';
  }

  get isCalendarActivity() {
    return !this.form.itemId;
  }
  async activities() {
    try {
      this.listLoading = true;
      const res = await getActivities({
        start: moment()
          .startOf('month')
          .startOf('week')
          .format('YYYY-MM-DD'),
        end: moment()
          .endOf('month')
          .endOf('week')
          .format('YYYY-MM-DD'),
      });
      this.activitiesArr = Object.values(this.filterEmptyValues(res)).map((item, index) => {
        // console.log(item);
        const obj = {
          title: item.title,
          start: moment(item.date).format('YYYY-MM-DD'),
          extendedProps: item,
        };
        return obj;
      });

      this.deduplication();
      // console.log(this.calendar!.getEvents());

      this.listLoading = false;
    } catch (err) {
      console.log(err);
    }
  }
  submit() {
    if (this.lockSubmit) return;
    this.lockSubmit = true;
    (this.$refs.form as HTMLFormElement).validate(async (valid) => {
      if (valid) {
        try {
          const tempObj: ToPost<Activity> = {
            title: this.form.name,
            time:
              !!this.form.startTime && !!this.form.endTime
                ? `${this.convertTimeAgain(this.form.startTime)} - ${this.convertTimeAgain(
                    this.form.endTime,
                  )}`
                : '',
            place: this.form.place,
            relatedPeople: this.form.relatedPeople,
            date: this.form.date,
            endDate: this.form.endDate,
          };

          const response = this.clickType
            ? await putActivity(this.form.id, tempObj)
            : await postActivity(tempObj);

          this.dialogFormVisible = false;
          const start = this.form.date;
          const end = moment(this.form.date)
            .add(1, 'day')
            .format('YYYY-MM-DD');
          if (!this.clickType) {
            this.calendar?.addEvent({
              title: tempObj.title,
              start,
              end,
              extendedProps: tempObj,
              _id: response._id,
            });
            this.$message.success('添加成功');
          } else {
            Object.entries(tempObj).forEach(([key, val]) => {
              this.form.event?.setExtendedProp(key, val);
            });

            this.form.event?.setStart(start);
            this.form.event?.setEnd(end);
            this.form.event?.setProp('title', this.form.name);
            this.$message.success('修改成功');
          }
          this.clearForm();
          this.lockSubmit = false;
        } catch (err) {
          this.$message.error((err as any).message);
          this.lockSubmit = false;
        }
        return true;
      } else {
        this.$message.error('error submit');
        this.lockSubmit = false;
        return false;
      }
    });
  }
  handleClose() {
    this.$confirm('确定删除？')
      .then((_) => {
        this.deleteFn();
      })
      .catch((err) => {});
  }
  async deleteFn() {
    try {
      const res = await deleteActivity(this.form.id);
      this.form.event?.remove();
      this.dialogFormVisible = false;
      this.$message.success('删除成功');
    } catch (err) {
      this.$message.error((err as any).message);
    }
  }
  filterEmptyValues(obj: Record<string, Activity[]>) {
    return Object.entries(obj).flatMap(([key, val]) => val);

    // return Object.keys(obj).reduce((result, key) => {
    //   const value = obj[key][0];
    //   if (value !== '' && value !== false && value !== undefined) {
    //     result[key] = value;
    //   }
    //   return result;
    // }, {}) as Record<string, Activity>;
  }
  async customClick(action: boolean) {
    this.listLoading = true;
    action ? this.calendar!.prev() : this.calendar!.next();
    const Res = await getActivities(
      action
        ? {
            start: moment()
              .subtract(1, 'months')
              .startOf('month')
              .format('YYYY-MM-DD'),
            end: moment()
              .subtract(1, 'months')
              .endOf('month')
              .format('YYYY-MM-DD'),
          }
        : {
            start: moment()
              .add(1, 'months')
              .startOf('month')
              .format('YYYY-MM-DD'),
            end: moment()
              .add(1, 'months')
              .endOf('month')
              .format('YYYY-MM-DD'),
          },
    );

    this.activitiesArr = Object.values(this.filterEmptyValues(Res)).map((item, index) => {
      const obj = {
        title: item.title,
        start: moment(item.date).format('YYYY-MM-DD'),
        extendedProps: item,
      };
      return obj;
    });
    // 对日历中所有的事件进行去重操作
    this.deduplication();
    this.listLoading = false;
  }
  clearForm() {
    this.form = { ...formDefaultProps };
    (this.$refs.form as HTMLFormElement)?.resetFields();
    (this.$refs.form as HTMLFormElement)?.clearValidate();
  }
  cancel() {
    this.dialogFormVisible = false;
    this.clearForm();
  }
  convertTime(timeStr) {
    const time = moment(timeStr, 'h:mm A').toDate();
    return time;
  }
  convertTimeAgain(date) {
    return moment(date, 'HH:mm')
      .format('h:mmA')
      .toLowerCase();
  }
  // 对日历中所有的事件进行去重操作
  deduplication() {
    this.activitiesArr.forEach((activitie, index) => {
      const exits = this.calendar!.getEvents().some((item) => {
        if (item._def.extendedProps._id == activitie.extendedProps._id) {
          return true;
        }
        return false;
      });
      if (!exits) {
        this.calendar!.addEvent(activitie!);
      }
    });
  }
}
